export default __webpack_public_path__ + "static/ay-logo-1cd4153e1646db225062fa26634351c6.svg";